import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { _keys, _values, filterDuplicates, flatArray, RuntimeModules } from '@nu-art/ts-common';
import { dispatch_ShowConflictResolution } from '../../_dispatchers/index.js';
import { TS_Icons } from '@nu-art/ts-styles/icons/index';
import './Panel_ConflictResolution.scss';
import { ConflictResolutionTree } from '../ConflictResolutionTree/ConflictResolutionTree.js';
export class Panel_ConflictResolution extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.expanded ??= false;
        state.dependencies = nextProps.dependencies;
        return state;
    }
    // ##################### Logic #####################
    resolveEntityLabel = () => {
        const module = RuntimeModules().filter(module => module.dbDef?.dbKey === this.props.dependencies.dbKey)[0];
        return module?.dbDef.entityName ?? 'Entity';
    };
    closePanel = () => {
        dispatch_ShowConflictResolution.dispatchUI();
    };
    resolveAmounts = () => {
        const dependencies = this.props.dependencies;
        const dependencyResults = _values(dependencies.dependencyMap);
        const collectionKeys = filterDuplicates(dependencyResults.map(result => _keys(result)).flat());
        const items = filterDuplicates(flatArray(dependencyResults.map(result => _values(result))));
        return {
            collections: collectionKeys.length,
            items: items.length,
        };
    };
    expand = () => {
        this.setState({ expanded: true });
    };
    // ##################### Render #####################
    render() {
        return _jsxs(LL_V_L, { id: 'panel__conflict-resolution', className: this.state.expanded ? 'expanded' : undefined, children: [this.render_Header(), this.render_Body()] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'panel__conflict-resolution__header', children: [this.resolveEntityLabel(), " Dependencies", _jsx(TS_Icons.x.component, { onClick: () => this.closePanel() })] });
    };
    render_Body = () => {
        if (!this.state.expanded)
            return this.render_Body_Closed();
        return this.render_Body_Expanded();
    };
    render_Body_Closed = () => {
        const amounts = this.resolveAmounts();
        return _jsxs(LL_V_L, { className: 'panel__conflict-resolution__body-closed', children: [_jsxs("p", { className: 'toast__conflict-resolution__body', children: [this.resolveEntityLabel(), " has ", amounts.items, " dependencies across ", amounts.collections, " collections"] }), _jsx(Button, { variant: 'primary', onClick: this.expand, children: "Show Dependencies" })] });
    };
    render_Body_Expanded = () => {
        return _jsx("div", { className: 'panel__conflict-resolution__tree-wrapper', children: _jsx(ConflictResolutionTree, { dependencies: this.state.dependencies }) });
    };
}
//# sourceMappingURL=Panel_ConflictResolution.js.map